import { AxiosInstance, InternalAxiosRequestConfig } from 'axios'

import { API_ROUTES } from '@/constants'

const IGNORED_REQUEST_URL_LIST = [API_ROUTES.user.nativeLanguages]

/**
 * Adds request and response logging interceptors to an Axios instance
 */
export const addAxiosLoggingInterceptor = (
	axiosInstance: AxiosInstance,
): void => {
	// Request interceptor to log outgoing requests
	axiosInstance.interceptors.request.use(
		(config: InternalAxiosRequestConfig) => {
			const url = `${config.baseURL || ''}${config.url || ''}`
			const shouldNotLog = IGNORED_REQUEST_URL_LIST.some((ignoredUrl) =>
				url.endsWith(ignoredUrl),
			)

			if (shouldNotLog) {
				return config
			}

			console.log(
				'\n🔵 [AXIOS REQUEST]',
				JSON.stringify(
					{
						timestamp: new Date().toISOString(),
						method: config.method?.toUpperCase(),
						url,
						headers: config.headers,
						payload: config.data,
					},
					null,
					2,
				),
			)
			return config
		},
	)

	// Response interceptor to log incoming responses (both success and error)
	axiosInstance.interceptors.response.use(
		(response) => {
			const url = `${response.config.baseURL || ''}${response.config.url || ''}`
			if (
				IGNORED_REQUEST_URL_LIST.some((ignoredUrl) => url.endsWith(ignoredUrl))
			) {
				return response
			}

			console.log(
				'\n🟢 [AXIOS SUCCESS RESPONSE]',
				JSON.stringify(
					{
						timestamp: new Date().toISOString(),
						status: response.status,
						statusText: response.statusText,
						method: response.config.method?.toUpperCase(),
						url,
						size: JSON.stringify(response.data).length,
						data: response.data,
					},
					null,
					2,
				),
			)
			return response
		},
		(error) => {
			const url = `${error.config?.baseURL || ''}${error.config?.url || ''}`
			if (
				IGNORED_REQUEST_URL_LIST.some((ignoredUrl) => url.endsWith(ignoredUrl))
			) {
				return Promise.reject(error)
			}

			console.log(
				'\n🔴 [AXIOS ERROR RESPONSE]',
				JSON.stringify(
					{
						timestamp: new Date().toISOString(),
						status: error.response?.status,
						statusText: error.response?.statusText,
						method: error.config?.method?.toUpperCase(),
						url,
						error: error.message,
						data: error.response?.data,
						headers: error.response?.headers,
					},
					null,
					2,
				),
			)
			return Promise.reject(error)
		},
	)
}
